import * as signalR from "@microsoft/signalr";

export const NotificationConnection = new signalR.HubConnectionBuilder()
  .withUrl(`${process.env.REACT_APP_API_BASE_URL}/notificationHub?role=Admin`) // Admin role
  .withAutomaticReconnect()
  .build();

export const startNotificationConnection = async () => {
  if (NotificationConnection.state !== signalR.HubConnectionState.Disconnected) {
    console.log(`SignalR connection state is ${NotificationConnection.state}, skipping start.`);
    return;
  }
  try {
    await NotificationConnection.start();
    console.log("SignalR connected (notificationHub)");
  } catch (err) {
    console.error("SignalR connection error: ", err);
    setTimeout(startNotificationConnection, 5000);
  }
};